import _get from 'lodash/get';
import { format as dateFnsFormat } from 'date-fns';
import { filterOngoingOrders } from 'helper/history-order';
import {
  CLEAR_HISTORY,
  FETCH_HISTORY,
  CANCEL_DELIVERY,
  FILTER_CANCEL_DELIVERY,
  CLEAR_CANCEL_STATUS,
  FETCH_CANCEL_REASONS,
  FETCH_ONGOING_DELIVERIES,
  UPDATE_ONGOING_ORDER_STATE_CHANGES,
  UPDATE_ONGOING_ORDER_COUNTING,
  FETCH_COMPLETED_DELIVERIES,
  FETCH_ALL_PREVIOUS_BOOKINGS_SUCCESS,
  FETCH_ALL_PREVIOUS_BOOKINGS,
  PAX_FETCH_ONGOING_DELIVERIES,
} from 'actions/history-actions';
import { ORDER_STATUS } from 'components/history/filter-form/filter-form';
import { THIRD_PARTY_SOURCE_ORDER_TYPES } from 'constants/order-constants';
import { transformCompletedOrders } from './transforms/completed-orders-transform';

const initialState = {
  historyData: {},
  historyNotification: {},
  unhappyNotifications: [],
  // ---v2---
  prevOngoingOrders: [],
  ongoingOrders: [],
  ongoingOrdersLastUpdate: '',
  latestOrderStateChanges: [],
  countingOngoingOrders: {
    total: 0,
    processing: 0, // ActiveDelivery, Scheduled
    allocating: 0, // Allocating
    pickingUp: 0, // PickingUp
    droppingOff: 0, // DroppingOff
  },
  completedOrders: [],
  completedOrdersSourceOptions: [],
  completedOrderQueryParam: {}, // use to refetch completed order in history-epics.js
  isPreviousBookingsLoading: false,
  isCompletedOrdersLoading: false,
  isOngoingOrdersLoading: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case CLEAR_HISTORY.SUCCESS: {
      return initialState;
    }

    case FETCH_HISTORY.SUCCESS: {
      const totalCount = action.data.totalCount || 0;
      return {
        ...state,
        isFetchingHistory: false,
        historyData: { ...action.data, totalCount },
      };
    }

    case CANCEL_DELIVERY.ERROR: {
      return { ...state, isCancelSucceed: false };
    }
    case CANCEL_DELIVERY.SUCCESS: {
      return { ...state, isCancelSucceed: true, cancelResponse: action.data };
    }
    case FILTER_CANCEL_DELIVERY.SUCCESS: {
      const { deliveryID: canceledDeliveryID } = action.data;
      const { historyData: { deliveries }, historyNotification } = state;

      const newDeliveries = deliveries.map(
        delivery =>
          delivery.deliveryID !== canceledDeliveryID
            ? delivery
            : {
                ...delivery,
                status: ORDER_STATUS.SENDER_CACNCELLED,
                isCancelableByUser: false,
              },
      );

      if (historyNotification[canceledDeliveryID]) {
        historyNotification[canceledDeliveryID].status = ORDER_STATUS.CANCELLED;
      }

      return {
        ...state,
        historyData: {
          ...state.historyData,
          deliveries: newDeliveries,
        },
        historyNotification,
      };
    }
    case CLEAR_CANCEL_STATUS: {
      return { ...state, isCancelSucceed: true };
    }
    case FETCH_CANCEL_REASONS.SUCCESS: {
      return { ...state, cancelReasons: action.data.cancelReasons };
    }
    case PAX_FETCH_ONGOING_DELIVERIES.START:
    case FETCH_ONGOING_DELIVERIES.START: {
      return {
        ...state,
        isOngoingOrdersLoading: true,
      };
    }
    case PAX_FETCH_ONGOING_DELIVERIES.SUCCESS:
    case FETCH_ONGOING_DELIVERIES.SUCCESS: {
      const ongoingOrders = _get(action, 'data.result.deliveries', []);
      return {
        ...state,
        prevOngoingOrders: state.ongoingOrders,
        ongoingOrders: filterOngoingOrders(ongoingOrders),
        isOngoingOrdersLoading: false,
        ongoingOrdersLastUpdate: dateFnsFormat(new Date(), 'HH:mm:ss'),
      };
    }

    case PAX_FETCH_ONGOING_DELIVERIES.ERROR:
    case FETCH_ONGOING_DELIVERIES.ERROR: {
      return {
        ...state,
        isOngoingOrdersLoading: false,
      };
    }

    case UPDATE_ONGOING_ORDER_COUNTING: {
      return {
        ...state,
        countingOngoingOrders: action.payload,
      };
    }

    case UPDATE_ONGOING_ORDER_STATE_CHANGES: {
      return {
        ...state,
        latestOrderStateChanges: action.payload,
      };
    }

    case FETCH_COMPLETED_DELIVERIES.START: {
      return {
        ...state,
        isCompletedOrdersLoading: true,
      };
    }

    case FETCH_COMPLETED_DELIVERIES.SUCCESS: {
      let completedOrders = _get(action.data, 'result.deliveries', []);

      const params = new URLSearchParams(action.params);
      const orderTypeParam = params.get('params.orderType');
      const thirdPartySource = THIRD_PARTY_SOURCE_ORDER_TYPES[orderTypeParam];

      if (thirdPartySource !== undefined) {
        completedOrders = completedOrders.filter(order => {
          if (thirdPartySource === THIRD_PARTY_SOURCE_ORDER_TYPES.REGULAR) {
            return !order.thirdPartySource;
          } else {
            return order.thirdPartySource === thirdPartySource;
          }
        });
      }

      const { orders, sourceOptions } = transformCompletedOrders(
        completedOrders,
      );

      return {
        ...state,
        completedOrderQueryParams: action.params,
        isCompletedOrdersLoading: false,
        completedOrders: orders,
        completedOrdersSourceOptions: sourceOptions,
      };
    }

    case FETCH_COMPLETED_DELIVERIES.ERROR: {
      return {
        ...state,
        isCompletedOrdersLoading: false,
      };
    }

    case FETCH_ALL_PREVIOUS_BOOKINGS: {
      return {
        ...state,
        isPreviousBookingsLoading: true,
      };
    }

    case FETCH_ALL_PREVIOUS_BOOKINGS_SUCCESS: {
      return {
        ...state,
        previousBookings: action.payload,
        isPreviousBookingsLoading: false,
      };
    }

    default:
      return state;
  }
};
